import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import SimplePage from "../components/article/SimplePage";
import { ApiResult } from "../lib/CmsApi";
import PageProps from "../lib/models/pageProps";

type InitialResult = ApiResult<"loadApManagement"> & {
  articles: ApiResult<"listApManagementArticles">["items"];
};
export default function Page(props: InitialResult) {
  return (
    <SimplePage
      route={"apManagement"}
      title={props.name}
      subLinks={props.articles.map(a => ({
        route: "apManagementArticle",
        params: {
          slug: a.slug
        },
        title: a.name
      }))}
      contents={{ items: props.contents }}
    />
  );
}

Page.getInitialProps = async ({
  api
}: InitialPropsContext): PageProps<InitialResult> => {
  const [content, articles] = await Promise.all([
    api.loadApManagement().catch(() => {
      throw new PageNotFoundError();
    }),
    api.listApManagementArticles().catch(() => ({ total: 0, items: [] }))
  ]);
  const pageProps = { ...content, articles: articles.items };
  let _pageImages;
  try {
    _pageImages = SimplePage.getImages({
      contents: { items: content.contents }
    });
  } catch (error) {
    console.error(error);
  }

  return { ...pageProps, _pageImages };
};
